import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DynamicForm from "Component/DynamicForm";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import CallOutNew from "Component/Headers/callOutNew";
import moment from "moment";
import {
  AttendanceDevice,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import SelectList from "../../../../../Component/SelectList/SelectList";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class InputType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clockinmodeid: 1,
      isbreakon: false,
      breakthreshold: `00:00:00`,
      helperText: "",
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
    this.UpdateBreakTime = this.UpdateBreakTime.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("attendancedevicepolicy");
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);

    this.props.onRef({
      onNext: this.OnNext,
    });
    const text = this.props.Language.attendancedevicepolicy.HtInputType;
    this.props.setHelperText({ helperText: text });
    const attendanceDeviceInfo = this.props.attendanceDeviceReducer;
    if (!this.isEmpty(attendanceDeviceInfo)) {
      const clockinmodeid = attendanceDeviceInfo.clockinmodeid
        ? attendanceDeviceInfo.clockinmodeid
        : 1;
      const isbreakon = attendanceDeviceInfo.isbreakon
        ? attendanceDeviceInfo.isbreakon
        : false;
      const breakthreshold = attendanceDeviceInfo.breakthreshold
        ? attendanceDeviceInfo.breakthreshold
        : `00:00:00`;
      this.setState({ clockinmodeid, isbreakon, breakthreshold }, () => {
        this.UpdateAttendanceDeviceReducer();
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  UpdateClockInMode(HtField, selectedItem) {
    this.HelperSliderFlag([HtField]);
    this.setState({ clockinmodeid: selectedItem.displayvalue }, () => {
      this.UpdateAttendanceDeviceReducer();
    });
  }

  UpdateBreakOn(HtField, selectedItem) {
    this.HelperSliderFlag([HtField]);
    this.setState({ isbreakon: selectedItem.displayvalue }, () => {
      this.UpdateAttendanceDeviceReducer();
    });
  }

  UpdateBreakTime(key, value) {
    let breakthreshold = this.state.breakthreshold.split(":");

    if (key == "hours") {
      breakthreshold = moment(
        `${value}:${breakthreshold[1]}:00`,
        "HH:mm:ss",
      ).format("HH:mm:ss");
    } else {
      breakthreshold = moment(
        `${breakthreshold[0]}:${value}:00`,
        "HH:mm:ss",
      ).format("HH:mm:ss");
    }

    this.setState({ breakthreshold }, () => {
      this.UpdateAttendanceDeviceReducer();
    });
  }

  UpdateAttendanceDeviceReducer = () => {
    const attendanceDeviceInfo = this.props.attendanceDeviceReducer;
    attendanceDeviceInfo.clockinmodeid = this.state.clockinmodeid;
    attendanceDeviceInfo.isbreakon = this.state.isbreakon;
    attendanceDeviceInfo.breakthreshold = this.state.breakthreshold;
    this.props.AttendanceDevice({ ...attendanceDeviceInfo });
  };

  OnNext = () => {
    this.UpdateAttendanceDeviceReducer();
    this.props.click();
  };

  OnSave(flag) {
    this.UpdateAttendanceDeviceReducer();
    this.props.SaveDevicePolicy(flag);
  }

  OnCancel() {
    this.props.Cancel(true);
  }

  HelperSliderFlag(HtField) {
    const text = get(this.props, `Language.attendancedevicepolicy[${HtField}]`);
    // let text = this.props.Language.attendancedevicepolicy[HtField]
    this.props.setHelperText({ helperText: text, open: true });
  }

  render() {
    const { classes } = this.props;

    const ClockInModes = [
      {
        displayvalue: 1,
        displayname: (
          <FormattedMessage
            id="LbBothClockinClockout"
            defaultMessage="Clock-in and Clock-out, both required"
          />
        ),
      },
      {
        displayvalue: 2,
        displayname: (
          <FormattedMessage
            id="LbOnlyClockin"
            defaultMessage="Only Clock-in is required"
          />
        ),
      },
    ];
    const options = [
      {
        displayvalue: true,
        displayname: <FormattedMessage id="LbYes" defaultMessage="Yes" />,
      },
      {
        displayvalue: false,
        displayname: <FormattedMessage id="LbNo" defaultMessage="No" />,
      },
    ];
    return (
      <div className={classes.root}>
        <div className="stepper-scroller padding-top-0">
          <div className="stepper-scroller-content">
            <div className="inner-wrapper opaque">
              <div className="form-group">
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbClockInMode"
                    defaultMessage="Do employees need to clock-in and clock-out, or only clock-in is sufficient ?"
                  />
                </p>
                <div className="">
                  <SelectList
                    data={ClockInModes}
                    Selected={this.state.clockinmodeid}
                    onSelected={this.UpdateClockInMode.bind(
                      this,
                      "HtClockInMode",
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="inner-wrapper opaque">
              <div className="form-group">
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbTrackBreakDurations"
                    defaultMessage="Would you like to track break durations between Clock-out and Clock-in times?"
                  />
                </p>
                <div className="">
                  <SelectList
                    data={options}
                    Selected={this.state.isbreakon}
                    onSelected={this.UpdateBreakOn.bind(
                      this,
                      "HtTrackBreakDurations",
                    )}
                  />
                </div>
              </div>
            </div>

            <div className="inner-wrapper opaque">
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="LbTrackBreakTime"
                  defaultMessage="How much time is allocated to employee as break-time?"
                />
              </p>

              <div
                className="display-flex margin-bottom-24"
                style={{ alignItems: "center" }}
              >
                <div style={{ width: 100, marginBottom: -16 }}>
                  <DynamicForm
                    fields={integerinputconverter({
                      value: this.state.breakthreshold.split(":")[0] || null,
                      placeholder: "",
                      min: 0,
                      max: 23,
                    })}
                    onChange={(value) => this.UpdateBreakTime("hours", value)}
                  />
                </div>
                <span className="normal-dark-secondary margin-left-8">
                  hours
                </span>
                <div style={{ width: 100, marginBottom: -16, marginLeft: 16 }}>
                  <DynamicForm
                    fields={integerinputconverter({
                      value: this.state.breakthreshold.split(":")[1] || null,
                      placeholder: "",
                      min: 0,
                      max: 59,
                    })}
                    onChange={(value) => this.UpdateBreakTime("minutes", value)}
                  />
                </div>
                <span className="normal-dark-secondary margin-left-8">
                  minutes
                </span>
              </div>

              <div className="margin-top-24">
                <CallOutNew
                  classnames="bg-light-blue width100"
                  header="⚠️ Allocated time can be subtracted from employee's total work duration in overtime payment calculations."
                  emoji=""
                  textcolor="#1e8ced"
                />
              </div>
            </div>
            {/* <div>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={this.OnNext.bind(this)}
              >
                <FormattedMessage id="BtNext" defaultMessage="Next" />
              </Button>
            </div> */}
            {/* <div className="draftbutton-wrapper">
                            <div className="draftclosebutton cursour-pointer" onClick={this.OnCancel.bind(this)}>X <span className="draftclosebutton-text"><FormattedMessage id="BtClose" defaultMessage="Close" /></span></div>

                            <div className="draftbutton-innerwrapper">
                                {this.state.isdraft == true ?
                                <span className="draftbutton cursour-pointer" onClick={this.OnSave.bind(this, 'SaveAsDraft')}>
                                     <Done />
                                     <span className="draft-option"><FormattedMessage id="BtSaveAsDraft" defaultMessage="Save As Draft" /></span>
                                </span>
                                :
                                <span className="draftbutton cursour-pointer" onClick={this.OnSave.bind(this, 'Save')}>
                                    <DoneAllIcon />
                                    <span className="draft-option"><FormattedMessage id="BtSave" defaultMessage="Save" /></span>
                                </span>
                                }
                            </div>
                        </div> */}
          </div>
        </div>
      </div>
    );
  }
}

InputType.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  attendanceDeviceReducer: state.attendanceDeviceReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      AttendanceDevice: (data) => AttendanceDevice(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(InputType)));
